module.exports = __webpack_public_path__ + "img/image88.dc3a95d0.jpg";